import {FC, useState} from 'react'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {RelatedFiles} from '../../core/_models'
import Swal from 'sweetalert2'
import {useIntl} from 'react-intl'
import withReactContent from 'sweetalert2-react-content'
import axios from 'axios'
import {useQueryClient} from 'react-query'

type Props = {
  RelatedFiles: RelatedFiles
}
const API_URL = process.env.REACT_APP_API_URL || 'api'

const RelatedFilesActionsCell: FC<Props> = ({RelatedFiles}) => {
  const [showPropertiesRegisterModal, setPropertiesRegisterModal] = useState<boolean>(false)
  const intl = useIntl()
  const queryClient = useQueryClient()

  function deleteMsgPropertyRegistries() {
    const MySwal = withReactContent(Swal)
    MySwal.fire({
      title: intl.formatMessage({id: 'RELATED_FILES.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (RelatedFiles.uuid !== undefined) deletePropertyRegistry()
      }
    })
  }

  async function deletePropertyRegistry() {
    try {
      await axios.delete(`${API_URL}/v1/links/${RelatedFiles.uuid}`)
      Swal.fire({
        icon: 'success',
        title: intl.formatMessage({id: 'RELATED_FILES.SWAL_DELETE'}),
        showConfirmButton: false,
        timer: 2000,
      })
      queryClient.invalidateQueries('link-conditionings-list-page=1&items_per_page=10')
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: intl.formatMessage({id: 'RELATED_FILES.SWAL_DELETE_ERROR'}),
        showConfirmButton: false,
        timer: 1500,
      })
    }
  }

  return (
    <div className='d-flex flex-line align-items-center'>
      {RelatedFiles.url && (
        <a
          href={RelatedFiles.url?.toString()}
          title='Abrir'
          target='_blank'
          rel='noreferrer'
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm
          bg-hover-light-primary mx-1'
        >
          <KTSVG path='/media/icons/duotune/communication/com001.svg' className='svg-icon-1' />
        </a>
      )}
      <button
        type='button'
        title='Editar'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm
        bg-hover-light-primary mx-1'
        onClick={deleteMsgPropertyRegistries}
      >
        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-1' />
      </button>
      <button
        type='button'
        title='Excluir'
        className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm
        bg-hover-light-danger mx-1'
        onClick={deleteMsgPropertyRegistries}
      >
        <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-1' />
      </button>
    </div>
  )
}

export {RelatedFilesActionsCell}
